
import React, { useState, useEffect } from "react";
import { Modal, Box, Typography, IconButton, CircularProgress } from "@mui/material";

import { GoogleMap, Marker, Circle } from "@react-google-maps/api";
import { MAPS_API_KEY } from "../../../../components/mapKey"; // adjust path if needed
import { useJsApiLoader } from "@react-google-maps/api";
import CustomButton from "../../../../components/CustomButton";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useTranslation } from "react-i18next";
import {toast,Toaster} from "react-hot-toast"
import LocationPermissionModal from "../../../../components/PermissionModal";
import {
  getPositionWithFallback,
  useLocationPermissionSync,
} from "../../../../utils/getPositionWithFallback";




const MapModal = ({ open, onClose, onContinue, taskLocation }) => {
  const [position, setPosition] = useState(null);
  const { t,i18n } = useTranslation();
const [locationError, setLocationError] = useState("");
  const [locationUnavailable, setLocationUnavailable] = useState(false);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [locationFailed, setLocationFailed] = useState(false);
    const { isLoaded } = useJsApiLoader({
  googleMapsApiKey: MAPS_API_KEY,
  libraries: ["places"],
});
const requestLocation = () => {
  if (!navigator.geolocation) {
    console.error("❌ Geolocation not supported");
    return () => {};
  }

  return getPositionWithFallback(
    (pos) => {
      const { latitude, longitude, accuracy } = pos.coords;

      const currentPosition = {
        lat: latitude,
        lng: longitude,
        accuracy_m: accuracy || 5,
      };

      console.log("📍 Current user location:", currentPosition);

      setPosition(currentPosition);
    },
    (err) => {
      console.error("❌ Failed to get current location:", err);

      // Never substitute the task's own location for the user's: that would pass validation
      setPosition(null);
      setLocationUnavailable(true);
      if (err?.code === err?.PERMISSION_DENIED) {
        setShowPermissionModal(true);
      } else {
        toast.error(
          t("locationFetchFailed") ||
            "Unable to fetch your location. Please make sure Location Services are on and try again."
        );
      }
    }
  );
};

useEffect(() => {
  console.log("🟡 MapModal opened:", open);
  console.log("🟡 taskLocation prop:", taskLocation);

  if (!open) return undefined;

  // Reset state when modal opens
  setLocationError("");
  setLocationFailed(false);
  setLocationUnavailable(false);
  setShowPermissionModal(false);
  setPosition(null);

  return requestLocation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [open]);

// Re-fetch when the user flips Location to Allow while the modal is open
useLocationPermissionSync({
  enabled: open,
  onGranted: () => {
    setShowPermissionModal(false);
    setLocationUnavailable(false);
    setPosition(null);
    requestLocation();
  },
  onDenied: () => {
    setPosition(null);
    setLocationUnavailable(true);
    setShowPermissionModal(true);
  },
});

const toRadians = (deg) => (deg * Math.PI) / 180;

const getDistanceMeters = (aLat, aLng, bLat, bLng) => {
  const R = 6371000;
  const dLat = toRadians(bLat - aLat);
  const dLng = toRadians(bLng - aLng);
  const lat1 = toRadians(aLat);
  const lat2 = toRadians(bLat);

  const h =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  return R * c;
};

// This modal is only ever used for task start/end (attendance punches use their own, separate
// MapModal), so it must validate against THIS TASK's own geofence — not the worker's registered
// attendance/company location. That's what /attendance/validate-location checks, which is a
// different location entirely and was wrongly flagging valid on-site task locations as invalid.
const validateLocation = (lat, lng) => {
  if (!taskLocation?.lat || !taskLocation?.lng) {
    // No task geofence to check against — nothing to validate.
    setLocationError("");
    return true;
  }

  const distance = getDistanceMeters(
    Number(taskLocation.lat),
    Number(taskLocation.lng),
    Number(lat),
    Number(lng)
  );
  const radius = Number(taskLocation.radius_m) || 100;
  const isValid = distance <= radius;

  if (!isValid) {
    setLocationError(
      i18n.language === "es"
        ? "Su ubicación no coincide con la ubicación registrada; por lo tanto, este registro será considerado inválido."
        : "Your location does not match the registered work location; therefore, this task will be considered invalid."
    );
    return false;
  }

  setLocationError("");
  toast.success(
    i18n.language === "es" ? "Ubicación validada correctamente" : "Location validated successfully"
  );
  return true;
};

  return (
    <Modal open={open} onClose={onClose}>
  <Box
    sx={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

      px: 2,
      py: 4,

      overflow: "hidden", // ❌ hides outer scrollbar
      boxSizing: "border-box",
      backgroundColor: "rgba(0,0,0,0.3)", // optional backdrop
    }}
  >
    <Box
      sx={{
        bgcolor: "white",
        borderRadius: "16px",   // keep rounded edges
        maxWidth: 600,
        width: "100%",
        maxHeight: "90vh",
        position: "relative",
p:2,
        overflowY: "auto",      // ✅ scrolling only inside modal
        paddingRight: "8px",    // fix border radius cutting

        // --- REMOVE SCROLLBAR ---
        scrollbarWidth: "none",       // Firefox
        "&::-webkit-scrollbar": {
          display: "none",            // Chrome / Edge / Safari
        },
      }}
    >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#333",

          }}
        >
          <CloseRoundedIcon />
        </IconButton>
        <Typography sx={{
          color: "#2C384C",
          fontSize: "26px",
          fontWeight: 600,
          textAlign: "center",
          fontFamily: 'Poppins, sans-serif',
        }}>{t("mapModal.title")}</Typography>

        <p style={{
          fontSize: "14px",
          color: "#8B8D97",
          textAlign: "center",
          fontFamily: 'Poppins, sans-serif',
        }}>{t("mapModal.subtitle")}</p>

        {/* {position && (
          <MapContainer
            center={[taskLocation.lat, taskLocation.lng]}
            zoom={17}
            style={{ height: 300, width: "100%", marginTop: "10px" }}
          > */}
          {/* {position?.lat != null && position?.lng != null && (
  <MapContainer
    center={[position.lat, position.lng]}
    zoom={17}
    style={{ height: 300, width: "100%", marginTop: "10px" }}
  >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <ResizeMap />

          
            <Marker position={[taskLocation.lat, taskLocation.lng]} icon={markerIcon} />

          
            <Circle
              center={[taskLocation.lat, taskLocation.lng]}
              radius={50}
              color="blue"
              fillColor="lightblue"
              fillOpacity={0.3}
            />

       
            <Marker
              position={[position.lat, position.lng]}
            
              icon={markerIcon}
              eventHandlers={{
                dragend: (e) => {
                  const newPos = e.target.getLatLng();
                  setPosition({
                    lat: newPos.lat,
                    lng: newPos.lng,
                    accuracy_m: 5,
                  });
                },
              }}
            />
          </MapContainer>
        )} */}


{(!isLoaded || position?.lat == null || position?.lng == null) && (
  <Box
    sx={{
      height: "300px",
      width: "100%",
      marginTop: "10px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 1.5,
      backgroundColor: "#F5F6F8",
      borderRadius: "8px",
    }}
  >
    {locationUnavailable ? (
      <>
        <Typography sx={{ fontSize: "14px", color: "red", fontFamily: "Poppins, sans-serif", textAlign: "center", px: 2 }}>
          {t("locationFetchFailed") ||
            "Unable to fetch your location. Please make sure Location Services are on and try again."}
        </Typography>
        <CustomButton
          label={t("retry") || "Retry"}
          size="small"
          onClick={() => {
            setLocationUnavailable(false);
            requestLocation();
          }}
        />
      </>
    ) : (
      <>
        <CircularProgress size={32} sx={{ color: "#006EC2" }} />
        <Typography sx={{ fontSize: "13px", color: "#8B8D97", fontFamily: "Poppins, sans-serif" }}>
          {!isLoaded ? t("mapModal.loadingMap") : t("mapModal.locatingYou")}
        </Typography>
      </>
    )}
  </Box>
)}

{isLoaded && position?.lat != null && position?.lng != null && (
  <GoogleMap
    center={{ lat: position.lat, lng: position.lng }}
    zoom={17}
    mapContainerStyle={{ height: "300px", width: "100%", marginTop: "10px" }}
  >
    {(() => {
      const taskLat = Number(taskLocation.lat);
      const taskLng = Number(taskLocation.lng);
      const userLat = Number(position.lat);
      const userLng = Number(position.lng);
      const distance = getDistanceMeters(taskLat, taskLng, userLat, userLng);
      // GPS can drift by several meters even when stationary, so use a practical threshold
      // to avoid showing what looks like a duplicate pin.
      const jitterThreshold = Math.max(20, Number(position.accuracy_m) || 0);
      const showUserMarker = distance > jitterThreshold;

      return (
        <>
    {/* Task location marker */}
    <Marker position={{ lat: taskLat, lng: taskLng }} />

    {/* 50m radius */}
    <Circle
      center={{ lat: taskLat, lng: taskLng }}
      radius={50}
      options={{
        fillColor: "lightblue",
        fillOpacity: 0.3,
        strokeColor: "blue",
      }}
    />

    {/* User marker */}
    {showUserMarker && (
      <Marker
        position={{ lat: userLat, lng: userLng }}
        draggable
        onDragEnd={(e) => {
          const lat = e.latLng.lat();
          const lng = e.latLng.lng();

          setPosition({
            lat,
            lng,
            accuracy_m: 5,
          });
        }}
      />
    )}
        </>
      );
    })()}
  </GoogleMap>
)}

   {position?.lat != null && position?.lng != null && (
  <>
    <Typography sx={{fontSize:"15px"}}>
      {t("map.latitude")}: {Number(position.lat).toFixed(6)}
    </Typography>
    <Typography  sx={{fontSize:"15px"}}>
      {t("map.longitude")}: {Number(position.lng).toFixed(6)}
    </Typography>
  </>
)}

{locationError && (
  <Typography
    sx={{
      color: "red",
      fontSize: "14px",
      mt: 1,
      textAlign: "center",
      fontFamily: "Poppins, sans-serif",
    }}
  >
    {locationError}
  </Typography>
)}

        <Box sx={{ width: "100%", mt: 3 }}>
          <CustomButton
            label={t("mapModal.continue")}
            size="small"
            fullWidth
            // onClick={() => {
            //   const payload = {
            //     geo: {
            //       lat: position.lat,
            //       lng: position.lng,
            //       accuracy_m: position.accuracy_m || 5,
            //     },
            //     local_timestamp: new Date().toISOString(),
            //   };
            //   console.log("📤 Selected location payload:", payload);
            //   onContinue(payload);
            // }}
onClick={async () => {
  if (!position) return;

  const payload = {
    geo: {
      lat: position.lat,
      lng: position.lng,
      accuracy_m: position.accuracy_m || 5,
    },
    local_timestamp: new Date().toISOString(),
  };

  // 👇 If already failed once → allow navigation
  if (locationFailed) {
    onContinue(payload);
    return;
  }

  const isValid = await validateLocation(position.lat, position.lng);

  if (!isValid) {
    setLocationFailed(true);   // 👈 next click will continue
    return;
  }

  onContinue(payload);
}}
            disabled={!position}
          />
        </Box>
      </Box>
      <LocationPermissionModal
        open={showPermissionModal}
        onCancel={() => setShowPermissionModal(false)}
      />
      </Box>
    </Modal>
  );
};

export default MapModal;
